import { formatRelativeTime } from '@/utils/formatRelativeTime';

// Hand-mirrored from the beacon API's daily-SMS ledger row; there is no codegen
// between the two. `services/ts/web/e2e/helpers.ts` mirrors the same row for the E2E specs.
export interface DailySmsHistoryItem {
	id: string;
	message?: string;
	// The moment the text was handed to the SMS provider. It is NOT proof the
	// handset received anything.
	sent_at?: string;
	to?: string;
	// "accepted" | "delivered" | "undelivered", or the legacy "sent", which
	// means the same as "accepted".
	status?: string;
	delivered_at?: string;
	// The carrier's own wording for a failure. Capped by the API.
	delivery_detail?: string;
}

// Handing a text to the SMS provider is not the same as a handset receiving it,
// and only a carrier delivery report can tell the two apart. Say which one we
// actually know, so nobody reads an acceptance as a delivery. Shared with the
// State Viewer's SMS tile so that debug surface can't drift back to treating
// every accepted status as a plain "sent" success.
export const describeDelivery = (
	row: Pick<DailySmsHistoryItem, 'status' | 'delivered_at' | 'sent_at'>,
): string => {
	if (row.status === 'delivered') {
		const at = row.delivered_at ?? row.sent_at;
		return at ? `Delivered ${formatRelativeTime(at)}` : 'Delivered';
	}
	if (row.status === 'undelivered') return 'Not delivered';
	return row.sent_at
		? `Sent ${formatRelativeTime(row.sent_at)} · delivery not confirmed`
		: 'Sent · delivery not confirmed';
};

export const DELIVERY_DETAIL_MAX = 120;

export const truncateDeliveryDetail = (detail?: string): string | null => {
	const trimmed = detail?.trim();
	if (!trimmed) return null;
	return trimmed.length > DELIVERY_DETAIL_MAX
		? `${trimmed.slice(0, DELIVERY_DETAIL_MAX)}…`
		: trimmed;
};
